import Container from '../../components/menu/Container';
import { useTranslation } from "react-i18next";
import DashboardRepresentante from './DashboardRepresentante';

export default function DashboardRepresentanteMain() {
  const { t } = useTranslation();

  // Visão única: o backend filtra automaticamente pelo representante logado
  // (getIdRepresentante); gestor sem representante vê o consolidado de todos.
  return (
    <Container>
      <div className="row">
        <div className="col-lg-12 mb-3">
          <div className="d-sm-flex align-items-center justify-content-between mb-4">
            <h1 className="h3 mb-0 text-gray">
              <i className="pi pi-chart-pie" style={{ fontSize: '2.0rem' }}></i> {t('gestaoRepresentante')}
            </h1>
          </div>
        </div>
      </div>

      <DashboardRepresentante />
    </Container>
  );
}
